<template>
  <div class="assets-list">
    <div class="top-container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="100px"
      >
        <div class="row">
          <el-form-item label="资产状态：" prop="assetsStatus">
            <el-select
              v-model="ruleForm.assetsStatus"
              placeholder="请选择"
              class="gray white"
              clearable
            >
              <el-option
                v-for="item in assetsStatusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否闲置：" prop="isIdle">
            <el-select
              v-model="ruleForm.isIdle"
              placeholder="请选择"
              class="gray white"
              clearable
            >
              <el-option
                v-for="item in isIdleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资产：" prop="assets">
            <el-input
              class="gray white"
              placeholder="请输入资产名称、编号"
              v-model="ruleForm.assets"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button class="btn-gray" @click="resetForm('ruleForm')"
              >重置</el-button
            >
            <el-button class="btn-blue" type="primary" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="使用部门：" prop="userDepartment">
            <SelectDepartmentTree
              :departmentList="userDepartment"
              :departmentId="ruleForm.userDepartment"
              @selectTreeNodeList="selectUserDepartmentList"
            >
            </SelectDepartmentTree>
          </el-form-item>
          <el-form-item label="使用人：" prop="userName">
            <el-input
              class="gray white"
              placeholder="请输入"
              v-model="ruleForm.userName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="存放地点：" prop="place">
            <el-select
              v-model="ruleForm.place"
              filterable
              clearable
              class="gray white"
              placeholder="请选择存放地点"
            >
              <el-option
                v-for="item in form.locationSetList"
                :key="item.id"
                :label="item.locationName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="assets-container">
      <div class="assets-title">
        <div class="title">资产列表</div>
        <div class="search">
          <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleUploadProperty
              ) !== -1
            "
            type="text"
            class="btn-blue add"
            @click="openAsset"
            >导入资产</el-button
          >
          <!-- <el-button
            type="text"
            class="btn-border-text-blue"
            @click="check"
            >发起清查</el-button
          > -->
          <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.rolePropertyLocation
              ) !== -1
            "
            type="text"
            class="btn-gray"
            @click="locationSet"
            >位置设置</el-button
          >
          <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleDownloadProperty
              ) !== -1
            "
            type="text"
            class="btn-gray"
            @click="downloadExcel"
            >资产导出</el-button
          >
        </div>
      </div>
      <div class="table" v-if="totalNum > 0">
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :min-width="item.width"
            :show-overflow-tooltip="item.showOverflowTooltip"
          />
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.status != 1 &&
                  OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleUpdateProperty
                  ) !== -1
                "
                type="text"
                class="btn-text mod-assets"
                @click="openUpdateDialog(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.isFree === 1 && scope.row.status != 1&&
                  OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleDelProperty
                  ) !== -1"
                type="text"
                class="btn-text mod-assets"
                @click="scrapAssets(scope.row.id)"
                >报废</el-button
              >
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(scope.row, 'labelBinding')">标签绑定</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row, 'recordQuery')">记录查询</el-dropdown-item>
                  <el-dropdown-item class="delete-assets" :command="beforeHandleCommand(scope.row, 'delete')">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div class="nothing" v-if="totalNum == 0">
        <div>
          <div>
            <img src="../../../../assets/nothing.png" />
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>

    <!-- 导入资产、位置设置、发起清查 -->
    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :modal="false"
      :with-header="false"
      :wrapperClosable="false"
    >
      <div class="drawer-title">
        <i class="el-icon-close" @click="closeDrawer"></i>
        <div v-if="isFlag != 4">
          <el-button type="text" class="btn-gray" @click="closeDrawer"
            >取消</el-button
          >
          <el-button type="text" class="btn-blue" @click="submitForm('form')">
            {{ isFlag == 2 ? "导入" : "保存" }}
          </el-button>
        </div>
        <div v-else class="location-container">
          <div class="top">
            <div class="canteen-name">
              <div class="canteen-title">三级部门</div>
              <el-select
                v-model="thirdDeptmentId"
                placeholder="请选择"
                class="w120"
                @change="changeLocation"
              >
                <el-option
                  v-for="item in thirdDeptmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <el-button type="text" class="btn-blue" @click="addLocation('form')"
            >新增位置</el-button
          >
        </div>
      </div>
      <div class="sub-title">
        <span class="sub-title-name">{{ subTitle }}</span>
        <el-upload
          v-if="isFlag == 4"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" type="text" class="btn-text"
            >导入位置</el-button
          >
        </el-upload>
      </div>
      <el-form :model="form" ref="form" class="demo-ruleForm demo-form" @submit.native.prevent>
        <!-- 导入资产 -->
        <div v-if="isFlag == 2">
          <el-form-item label="所属部门">
            <SelectDepartmentTree
              :departmentList="departmentList"
              :departmentId="departmentId"
              @selectTreeNodeList="selectTreeNodeList"
            >
            </SelectDepartmentTree>
          </el-form-item>
          <el-form-item label="上传附件">
            <upload-files
              :image="form.enclosure"
              :isFileStream="true"
              :fileArr="fileList"
              @uploadFile="cooperationAgreement"
            />
          </el-form-item>
        </div>

        <!-- 编辑 -->
        <div v-if="isFlag == 1">
          <el-form-item label="资产编号">
            <el-input
              class="gray white"
              placeholder="请输入"
              v-model="form.code"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="资产名称">
            <el-input
              class="gray white"
              placeholder="请输入"
              v-model="form.name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="价值">
            <el-input
              class="gray white"
              placeholder="请输入"
              v-model="form.price"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="取得日期">
            <el-date-picker
              v-model="form.buyTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="折旧月数">
            <el-input
              class="gray white"
              placeholder="请输入"
              v-model="form.useTimeLimit"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌">
            <el-input
              class="gray white"
              placeholder="请输入"
              v-model="form.brand"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input
              class="gray white"
              placeholder="请输入"
              v-model="form.spec"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="坐落位置">
            <el-select
              v-model="form.locationName"
              placeholder="请选择"
              class="gray white"
            >
              <el-option
                v-for="item in form.locationSetList"
                :key="item.id"
                :label="item.locationName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 位置设置 -->
        <div v-if="isFlag == 4">
          <div
            class="location-set"
            v-for="(locationSetList, index) in form.locationSetList"
            :key="index"
          >
            <i
              class="el-icon-error"
              @click="removeLocationSetList(locationSetList.id, index)"
            ></i>
            <el-form-item
              v-if="!locationSetList.isModLocatine"
              label="位置设置"
              :prop="'locationSetList.' + index + '.locationName'"
              :rules="{
                required: true,
                message: '请输入正确位置信息',
                trigger: 'blur',
              }"
            >
              <el-input
                class="gray white"
                placeholder="请输入"
                v-model="locationSetList.locationName"
                @change="
                  changeLocationSetList(locationSetList.locationName, index)
                "
                clearable
              ></el-input>
            </el-form-item>
            <div v-else class="mod-location">
              <p class="location-info">
                位置设置：{{ locationSetList.locationName }}
              </p>
              <i class="el-icon-edit" @click="modLocationSetList(index)"></i>
            </div>
          </div>
        </div>
      </el-form>
    </el-drawer>

    <!-- 发起清查 -->
    <all-department-people-dialog
      :departmentDialog="departmentDialog"
      :departmentDialogTitle="departmentDialogTitle"
      @allOPenOrCloseDepartmentDialog="allOPenOrCloseDepartmentDialog"
      @allSubmitSelectData="allSubmitSelectData"
    ></all-department-people-dialog>

    <!-- 标签绑定 -->
    <el-dialog
      title="标签绑定"
      class="label-banding"
      :visible.sync="dialogLabelBindingVisible"
      width="540px"
      top="30vh"
      :before-close="handleLabelBindingClose"
    >
      <el-form
        :model="labelBindingForm"
        :rules="labelBindingRules"
        ref="labelBindingForm"
      >
        <el-form-item label="RFID标签编码" prop="tagCode">
          <el-input class="gray white" v-model="labelBindingForm.tagCode" placeholder="请输入正确的编码，例如A0000001" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLabelBindingClose">取 消</el-button>
        <el-button type="primary" @click="confirmLabelBinding('labelBindingForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 记录查询 -->
    <el-dialog
      title="记录查询"
      class="record-query"
      :visible.sync="dialogRecordQueryVisible"
      width="840px"
      :before-close="handleRecordQueryClose"
    >
      <div class="table">
        <el-table
          :data="recordQueryTableData"
          style="width: 100%"
          height="360px"
        >
          <el-table-column
            v-for="(item, index) in recordQueryTableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :min-width="item.width"
            :show-overflow-tooltip="item.showOverflowTooltip"
          />
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="recordQueryTotalNum"
            :currentPage="recordQueryCurrentPage"
            @queryChange="recordQueryQueryChange"
          ></pagination-tpl>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import Assets from "@/models/assets.js";
import Staff from "@/models/staff.js";
import uploadFiles from "@/components/upload-files.vue";
import PaginationTpl from "@/components/PaginationTpl.vue";
import SelectDepartmentTree from "@/components/select-department-tree";
import AllDepartmentPeopleDialog from "@/components/all-department-people-dialog.vue";
import { statusMixins } from "@/common/mixins/status/status.js";
import { operationMixins } from "@/common/mixins/operation/operation.js";
import {
  formatTimeToDate,
  formaTimeToSecond,
  mapChildThirdDisable,
  mapId2,
  handleAmount,
} from "@/common/js/utils.js";
export default {
  mixins: [statusMixins, operationMixins],

  components: {
    PaginationTpl,
    uploadFiles,
    SelectDepartmentTree,
    AllDepartmentPeopleDialog,
  },

  data() {
    return {
      ruleForm: {
        assetsStatus: "",
        isIdle: "",
        assets: "",
        userDepartment: 0,
        userName: "",
        place: "",
      },
      userDepartment: [],
      /* 资产状态 */
      assetsStatusList: [
        {
          id: 1,
          name: "报废",
        },
        {
          id: 2,
          name: "正常",
        },
        {
          id: 3,
          name: "遗失",
        },
        {
          id: 4,
          name: "损坏",
        },
      ],
      /* 是否闲置 */
      isIdleList: [
        {
          id: 0,
          name: "否",
        },
        {
          id: 1,
          name: "是",
        },
      ],

      totalNum: 0,
      currentPage: 1,
      tableData: [],
      tableTitleList: [
        {
          prop: "code",
          lable: "资产编号",
          width: "150",
          showOverflowTooltip: true,
        },
        {
          prop: "name",
          lable: "资产名称",
          width: "120",
          showOverflowTooltip: true,
        },
        {
          prop: "price",
          lable: "价值",
          width: "80",
          showOverflowTooltip: true,
        },
        {
          prop: "buyTime",
          lable: "取得日期",
          width: "100",
          showOverflowTooltip: true,
        },
        {
          prop: "belongingDepartment",
          lable: "所属部门",
          width: "100",
          showOverflowTooltip: true,
        },
        {
          prop: "departmentName",
          lable: "使用部门",
          width: "100",
          showOverflowTooltip: true,
        },
        {
          prop: "userName",
          lable: "使用人",
          width: "80",
          showOverflowTooltip: true,
        },
        {
          prop: "useTimeLimit",
          lable: "折旧月数",
          width: "90",
          showOverflowTooltip: true,
        },
        {
          prop: "brand",
          lable: "品牌",
          width: "100",
          showOverflowTooltip: true,
        },
        {
          prop: "spec",
          lable: "规格型号",
          width: "100",
          showOverflowTooltip: true,
        },
        {
          prop: "locationName",
          lable: "坐落位置",
          width: "140",
          showOverflowTooltip: true,
        },
        {
          prop: "statusValue",
          lable: "资产状态",
          width: "80",
          showOverflowTooltip: true,
        },
        {
          prop: "freeValue",
          lable: "是否闲置",
          width: "80",
          showOverflowTooltip: true,
        },
      ],

      drawer: false,
      thirdDeptmentId: "",
      thirdDeptmentList: [],
      /* 1：编辑; 2：导入资产; 3：发起清查; 4：位置设置 */
      subTitle: "",
      isFlag: "",
      form: {
        /* 资产id */
        id: "",
        /* 3级部门id */
        groupId: "",
        enclosure: [],
        code: "",
        name: "",
        price: "",
        buyTime: "",
        useTimeLimit: "",
        brand: "",
        spec: "",
        locationName: "",
        locationSetList: [],
      },
      departmentId: 0,
      departmentList: [],
      fileList: [],

      departmentDialog: false,
      departmentDialogTitle: "发起清查",

      dialogLabelBindingVisible: false,
      labelBindingForm: {
        id: '',
        tagCode: ''
      },
      labelBindingRules: {
        tagCode: [{ required: true, message: "请输入RFID标签编码", trigger: "blur" }]
      },

      dialogRecordQueryVisible: false,
      recordQueryTableData: [],
      recordQueryTableTitleList: [
        {
          prop: "time",
          lable: "出入时间",
          width: "150",
          showOverflowTooltip: true,
        },
        {
          prop: "typeValue",
          lable: "类型",
          showOverflowTooltip: true,
        },
        {
          prop: "equipment",
          lable: "设备",
          width: "150",
          showOverflowTooltip: true,
        },
      ],
      propertyId: '',
      recordQueryTotalNum: 0,
      recordQueryCurrentPage: 1,
    };
  },

  created() {
    config();
    this.initAssetsList();
    this.initDepartment();
    this.initThirdDeptment();
  },

  methods: {
    initDepartment() {
      /* 权限上线以后用以下接口 */
      let keyword = "property";
      Staff.getModuleManagerDepartmentList(keyword).then((res) => {
        if (res.success) {
          let arr = mapChildThirdDisable(res.result);
          this.departmentList = mapId2(arr, this.departmentId);
          let arr2 = mapChildThirdDisable(res.result);
          this.userDepartment = mapId2(arr2, this.ruleForm.userDepartment);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取当前用户作为某模块管理员的部门管理范围 */
    initThirdDeptment() {
      let keyword = "property";
      Assets.getKeywordThirdDepartment(keyword).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            arr.push(obj);
          });
          this.thirdDeptmentList = arr;
          this.thirdDeptmentId = arr.length > 0 ? arr[0].id : "";
          this.initLocationList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 资产列表 */
    initAssetsList() {
      let currentPage = this.currentPage;
      let status = this.ruleForm.assetsStatus;
      let isFree = this.ruleForm.isIdle;
      let name = this.ruleForm.assets;
      let deptId =
        this.ruleForm.userDepartment == 0 ? "" : this.ruleForm.userDepartment;
      let username = this.ruleForm.userName;
      let locationId = this.ruleForm.place;
      let data = {
        status,
        isFree,
        name,
        deptId,
        username,
        locationId,
      };
      Assets.getAssetLsit(currentPage, data).then((res) => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = [];
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.code = value.code;
            obj.name = value.name;
            obj.epc = value.epc;
            obj.price = handleAmount(value.price, 2);
            obj.brand = value.brand;
            obj.spec = value.spec;
            obj.groupId = value.groupId;
            obj.userName = value.ownerName;
            obj.buyTime = formatTimeToDate(value.buyTime);
            obj.belongingDepartment = value.groupName;
            obj.departmentName = value.departmentName;
            obj.useTimeLimit = value.useTimeLimit;
            obj.locationName = value.locationName;
            obj.locationId = value.locationId;
            obj.status = value.status;
            obj.statusValue = this.FIXED_ASSETS_STATUS[value.status];
            obj.isFree = value.isFree;
            obj.freeValue = value.isFree === 0 ? "否" : "是";
            obj.flagValue = value.flag === 0 ? "否" : "是";
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 获取坐落位置集合 */
    initLocationList() {
      let name = "";
      let groupId = this.thirdDeptmentId;
      Assets.getLocationList(name, groupId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.locationName = i.name;
            obj.isModLocatine = 1;
            arr.push(obj);
          });
          this.form.locationSetList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initAssetsList();
    },

    /* 重置 */
    resetForm(formName) {
      this.ruleForm.userDepartment = 0;
      this.$nextTick(() => {
        this.$bus.emit("getFepartmentId", 0);
      });
      this.$refs[formName].resetFields();
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initAssetsList();
    },

    
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command){
      return {
        'value': value,
        'command':command
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "labelBinding":
          this.labelBindingForm.id = command.value.id
          this.labelBindingForm.tagCode = command.value.epc
          this.dialogLabelBindingVisible = true
          break;
        case "recordQuery":
          this.propertyId = command.value.id
          this.initRecordQuery('open')
          break;
        case "delete":
          this.removeAsset(command.value.id)
          break;
      }
    },

    handleLabelBindingClose() {
      this.labelBindingForm.id = ''
      this.labelBindingForm.tagCode = ''
      this.dialogLabelBindingVisible = false
    },

    confirmLabelBinding(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.labelBindingForm.id,
            epc: this.labelBindingForm.tagCode
          }
          Assets.postModRFID(data).then((res) => {
            if (res.success) {
              this.initAssetsList();
              this.handleLabelBindingClose()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    initRecordQuery(isOpen) {
      let propertyId = this.propertyId
      let currentPage = this.recordQueryCurrentPage
      Assets.getInAndOutRecordList(currentPage, propertyId).then((res) => {
        if (res.success) {
          this.recordQueryTotalNum = res.result.totalNum;
          let arr = [];
          res.result.items.map((value) => {
            let obj = {};
            obj.time = value.alarmTime ? formaTimeToSecond(value.alarmTime):'/';
            obj.equipment = value.deviceNo;
            obj.type = value.direction;
            obj.typeValue = value.direction === 1 ? "出" : "入";
            arr.push(obj);
          });
          this.recordQueryTableData = arr;
          if(isOpen === 'open') this.dialogRecordQueryVisible = true
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleRecordQueryClose() {
      this.propertyId = ''
      this.dialogRecordQueryVisible = false
    },

    recordQueryQueryChange(data) {
      this.recordQueryCurrentPage = data.currentPage;
      this.initRecordQuery('noOpen')
    },

    /* 多选 */
    handleSelectionChange(val) {},

    /* 资产导出 */
    downloadExcel() {
      let currentPage = this.currentPage;
      let status = this.ruleForm.assetsStatus;
      let isFree = this.ruleForm.isIdle;
      let assets = this.ruleForm.assets;
      let deptId =
        this.ruleForm.userDepartment == 0 ? "" : this.ruleForm.userDepartment;
      let userName = this.ruleForm.userName;
      let locationId = this.ruleForm.place;
      let data = {
        currentPage,
        status,
        isFree,
        assets,
        deptId,
        userName,
        locationId,
      };
      Assets.downloadAssetList(data).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },

    /* 报废资产 */
    scrapAssets(id) {
      this.$confirm("资产报废后不可恢复，是否继续？", "确认报废资产", {
        confirmButtonText: "报废",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id,
        };
        Assets.postScrapAssets(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "报废成功",
            });
            this.initAssetsList();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      });
    },

    /* 删除资产 */
    removeAsset(id) {
      this.$confirm("资产删除后不可恢复，是否继续？", "确认删除资产", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id,
        };
        Assets.postDelAssets(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.initAssetsList();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      });
    },

    selectTreeNodeList(v) {
      this.form.groupId = v.id2;
    },

    selectUserDepartmentList(v) {
      this.ruleForm.userDepartment = v.id2;
    },

    /* 开启导入资产 */
    openAsset() {
      this.isFlag = 2;
      this.subTitle = "导入资产";
      this.drawer = true;
    },

    /* 关闭抽屉 */
    closeDrawer() {
      this.departmentId = 0;
      this.$nextTick(() => {
        this.$bus.emit("getFepartmentId", 0);
      });
      this.form.enclosure = [];
      this.enclosurePlace = [];
      this.fileList = [];
      this.$bus.emit("clearImgFiles");
      this.drawer = false;
    },

    /* 获取上传附件 */
    cooperationAgreement(v) {
      this.form.enclosure = v;
    },

    /* 编辑 */
    openUpdateDialog(row) {
      this.isFlag = 1;
      this.subTitle = "编辑";
      this.form.id = row.id;
      this.form.code = row.code;
      this.form.name = row.name;
      this.form.price = row.price;
      this.form.buyTime = row.buyTime;
      this.form.useTimeLimit = row.useTimeLimit;
      this.form.brand = row.brand;
      this.form.spec = row.spec;
      this.form.locationName = row.locationId;
      this.thirdDeptmentId = row.groupId;
      this.initLocationList();
      this.drawer = true;
    },

    /* 开启位置设置 */
    locationSet() {
      this.isFlag = 4;
      this.subTitle = "位置设置";
      this.drawer = true;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isFlag == 2) this.assetImport();
          if (this.isFlag == 1) this.modAssets();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 资产导入 */
    assetImport() {
      let file = this.form.enclosure.length > 0 ? this.form.enclosure[0] : "";
      let groupId = this.form.groupId;
      if (groupId === "") {
        this.$message.error("请选择所属部门");
        return false;
      }
      if (file === "") {
        this.$message.error("请选择上传附件");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("groupId", groupId);
      Assets.assetImport(formData).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.initAssetsList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 编辑资产 */
    modAssets() {
      let data = {
        brand: this.form.brand,
        buyTime: this.form.buyTime,
        code: this.form.code,
        id: this.form.id,
        locationId: this.form.locationName,
        name: this.form.name,
        price: handleAmount(this.form.price, 1),
        spec: this.form.spec,
        useTimeLimit: this.form.useTimeLimit,
      };
      Assets.postModAssets(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.closeDrawer();
          this.initAssetsList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    addLocation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            locationName: "",
            /* 是否修改存放地址 1：是; 0:否 */
            isModLocatine: 0,
          };
          this.form.locationSetList.unshift(obj);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 删除存放地址 */
    removeLocationSetList(id, index) {
      this.$confirm("位置删除后不可恢复，是否继续？", "确认删除位置", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        if (!id) {
          this.form.locationSetList.splice(index, 1);
        } else {
          Assets.postDelLocation(id).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.initLocationList();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        }
      });
    },

    /* 编辑存放地址 */
    modLocationSetList(index) {
      let isFlag = false;
      let arr = [];
      this.form.locationSetList.map((i) => {
        if (arr.indexOf(i.locationName) != -1) {
          isFlag = true;
        } else {
          arr.push(i.locationName);
        }
      });
      if (isFlag) {
        this.form.locationSetList[index].locationName = "";
        this.$message.error("位置已存在");
        return false;
      }
      this.form.locationSetList[index].isModLocatine = 0;
    },

    /* 保存存放地址 */
    changeLocationSetList(name, index) {
      if (name === "") {
        this.$message.error("请输入存放位置");
        return;
      }
      let isFlag = false;
      let arr = [];
      this.form.locationSetList.map((i) => {
        if (arr.indexOf(i.locationName) != -1) {
          isFlag = true;
        } else {
          arr.push(i.locationName);
        }
      });

      if (isFlag) {
        this.form.locationSetList[index].locationName = "";
        this.$message.error("位置已存在");
        return;
      }
      this.form.locationSetList[index].isModLocatine = 1;
      let groupId = this.thirdDeptmentId;
      let data = {
        name,
        groupId,
      };
      if (!this.form.locationSetList[index].id) {
        this.addLocationSetList(data);
      } else {
        data.id = this.form.locationSetList[index].id;
        this.modLocation(data);
      }
    },

    /* 新增坐落位置 */
    addLocationSetList(data) {
      Assets.postAddLocation(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.initLocationList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改坐落位置 */
    modLocation(data) {
      Assets.postModLocation(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.initLocationList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 开启发起清查 */
    check() {
      this.departmentDialog = true;
    },

    /* 关闭发起清查弹窗 */
    allOPenOrCloseDepartmentDialog(data) {
      this.departmentDialog = data;
    },

    /* 确定发起清查弹窗 */
    allSubmitSelectData(v) {
      let userIds = [];
      v.map((i) => {
        userIds.push(i.id2);
      });
      let data = {
        userIds,
      };
      Assets.postAssetsCheck(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "清查成功",
          });
          this.departmentDialog = false;
          this.initAssetsList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    changeLocation() {
      this.initLocationList();
    },

    uploadExcel(file) {
      let groupId = this.thirdDeptmentId;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("groupId", groupId);
      Assets.placeImport(formData).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.initLocationList()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    }
  },
};
</script>

<style lang='scss'>
.assets-list {
  flex: 1;
  width: 100%;
  background: $bg-WhiteSmoke;
  @include flex-column-start;
  .top-container {
    width: 100%;
    box-sizing: border-box;
    background: $bg-white;
    padding: 10px;
    .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      width: 25%;
      margin-bottom: 10px;
      .el-input__prefix, .el-input__suffix {
        top: -2px;
      }
    }
    .row {
      @include flex-start;
      .btn {
        .el-form-item__content {
          margin-left: 20px !important;
          display: flex;
        }
      }
    }
  }
  .assets-container {
    flex: 1;
    width: 100%;
    margin-top: 20px;
    padding: 8px 10px;
    background: $bg-white;
    box-sizing: border-box;
    position: relative;
    .assets-title {
      @include flex-between;
      margin-bottom: 20px;
      .title {
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
      }
      .search {
        display: flex;
        .add {
          margin-left: 12px;
          padding: 0;
        }
      }
    }

    .nothing {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 157px;
        height: 157px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
  }

  .location-container {
    @include flex-start;
    .top {
      @include flex-start;
      padding: 20px;
      .el-button {
        padding: 0px;
      }
      .canteen-name {
        @include flex-center;
        font-size: $fs-small-l;
        border: 1px solid $bg-ShallowLightSnow;
        .canteen-title {
          height: 32px;
          line-height: 32px;
          padding-left: 19px;
          font-weight: 400;
          color: $color-LightGrey;
        }
        .el-input__inner {
          border: none;
        }
      }
    }
  }

  .sub-title {
    font-size: $fs-medium-s;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-Step;
    width: 100%;
    @include flex-end;
    .sub-title-name {
      text-align: left;
      flex: 1;
    }
    .upload {
      .el-button {
        padding: 0px;
      }
    }
  }
  .el-drawer__wrapper {
    top: 260px !important;
    right: 20px !important;
    .el-form-item {
      margin-bottom: 0px;
    }
  }
  .select-department-tree {
    width: 100%;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-dialog__body {
    .el-form {
      display: flex;
      justify-content: space-between;
      padding-bottom: 0px;
      .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:before {
        display: none;
      }
      .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label::after {
        content: "*";
        color: $bg-Required;
        margin-left: 4px;
      }
      .el-form-item__label {
        width: 100%;
        line-height: 22px;
        text-align: left;
      }
    }
  }

  #department-dialog-component .dialog-footer {
    height: 70px;
    margin-right: 20px;
    @include flex-end;
  }

  .label-banding {
    .el-form {
      box-sizing: border-box;
      padding-top: 0px;
      padding-bottom: 20px;
      .el-form-item {
        width: 100%;
      }
    }
    .el-dialog__header {
      border: none;
    }
    .el-dialog__footer {
      border: none;
      @include flex-end;
      padding-top: 0px;
    }
  }

  .record-query {
    .el-dialog__body {
      padding: 20px;
    }
  }

  .demo-form {
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      display: none;
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label::after {
      content: "*";
      color: $bg-Required;
      margin-left: 4px;
    }
    .el-form-item__label {
      width: 100%;
      line-height: 22px;
      text-align: left;
    }
    .location-set {
      width: 100%;
      min-height: 72px;
      margin-bottom: 14px;
      box-sizing: border-box;
      background: $bg-ChangeDepartmentTree;
      padding: 16px 12px 18px 12px;
      position: relative;
      .el-icon-error {
        position: absolute;
        right: -8px;
        top: -8px;
        color: $color-ColdAsh;
      }
      .mod-location {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-grey;
        @include flex-between-end;
        .location-info {
          margin-right: 35px;
          line-height: 20px;
          text-align: left;
        }
      }
    }
  }

  .el-dropdown-link {
    color: $color-DeepReddishBlue;
    cursor: pointer;
  }
  .mod-assets {
    margin-right: 10px;
    margin-left: 0px;
  }
}

.delete-assets {
  color: $color-Crimson;
}
</style>
